// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Yq-z","outfitFeedbackSection":"Zq-z"};